import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeEmailDomainCreate,
  detail: routeEmailDomainDetail,
  home: routeEmailDomainHome,
  root: routeEmailDomainRoot,
} = createDoctypeRoutes({
  createName: 'new-email-domain',
  createPath: 'new-email-domain',
  detailName: 'email-domain-detail',
  doctype: DOCTYPES.EMAIL_DOMAIN,
  homeName: 'email-domain',
  path: 'email-domain',
  views: {
    create: async () =>
      await import('@/components/viewsExternal/settings/email/emailDomain/AddEmailDomain.vue'),
    detail: async () =>
      await import('@/components/viewsExternal/settings/email/emailDomain/ViewEmailDomain.vue'),
    list: async () =>
      await import('@/components/viewsExternal/settings/email/ViewEmailSettings.vue'),
  },
})

export {
  routeEmailDomainCreate,
  routeEmailDomainDetail,
  routeEmailDomainHome,
  routeEmailDomainRoot,
}
